import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NbAccordionModule, NbButtonModule, NbCardModule,NbSpinnerModule } from '@nebular/theme';
import { RequestForApprovalsComponent } from './request-for-approvals.component';
import { ApprovalDetailsModule } from './approval-details/approval-details.module';
import { RequestConfirmationDialogComponent } from './request-confirmation-dialog/request-confirmation-dialog.component';
import {ApprovalModule}  from './appoval/approval.module';
import { RemindersModule } from '../../dynamic-stack/reminders/reminders.module';
const component = RequestForApprovalsComponent

@NgModule({
  declarations: [component, RequestConfirmationDialogComponent],
  imports: [
    CommonModule,
    NbButtonModule,
    FlexLayoutModule,
    ApprovalDetailsModule,
    NbAccordionModule,
    NbCardModule,
    ApprovalModule,
    NbSpinnerModule,
    RemindersModule
  ],
  exports: [component]
})
export class RequestForApprovalsModule { }
